var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import cn from "classnames";
import { bem } from "@react-md/utils";
import { useTableConfig } from "./config";
var block = bem("rmd-tr");
/**
 * Creates a `<tr>` element with some general styles that are inherited from the
 * base table configuration.
 */
export var TableRow = forwardRef(function TableRow(_a, ref) {
    var className = _a.className, propDisableHover = _a.disableHover, propDisableBorders = _a.disableBorders, children = _a.children, _b = _a.selected, selected = _b === void 0 ? false : _b, _c = _a.clickable, clickable = _c === void 0 ? false : _c, props = __rest(_a, ["className", "disableHover", "disableBorders", "children", "selected", "clickable"]);
    var _d = useTableConfig({
        disableHover: propDisableHover,
        disableBorders: propDisableBorders,
    }), disableHover = _d.disableHover, disableBorders = _d.disableBorders;
    return (React.createElement("tr", __assign({}, props, { ref: ref, className: cn(block({
            bordered: !disableBorders,
            hoverable: !disableHover,
            clickable: clickable,
            selected: selected,
            "selected-hoverable": selected && !disableHover,
        }), className) }), children));
});
/* istanbul ignore next */
if (process.env.NODE_ENV !== "production") {
    try {
        var PropTypes = require("prop-types");
        TableRow.propTypes = {
            className: PropTypes.string,
            children: PropTypes.node,
            disableHover: PropTypes.bool,
            disableBorders: PropTypes.bool,
            selected: PropTypes.bool,
            clickable: PropTypes.bool,
        };
    }
    catch (e) { }
}
//# sourceMappingURL=TableRow.js.map